<template>
  <!--Update 23/05/2022 09:58:08  d:\projects\newProject\src\components\customers\testingreqEdit.vue-->
  <v-card :loading="loading">      
    <v-form
      ref="form"
      v-model="formValid"
      :lazy-validation="lazy"
    >
      <v-container fluid fill-height >
        <v-row no-gutters v-if="$store.getters.isAuthen">

          <v-col cols="12" sm="12">
            <v-row no-gutters>
              <v-col cols="12" sm="6" class="pr-2">
                <v-text-field counter="4" :dense="text_filled" :filled="text_filled"
                  label="_ID_"
                  v-model="itemSelected.ID"
                  :rules="rules.ID"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-text-field ref="ReqOnlineNo" counter="50" label="_ReqOnlineNo_" v-model="itemSelected.ReqOnlineNo" :rules="rules.ReqOnlineNo" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-text-field ref="ReqNo" counter="50" label="_ReqNo_" v-model="itemSelected.ReqNo" :rules="rules.ReqNo" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <date-input ref="DateReceived" label="_DateReceived_" v-model="itemSelected.DateReceived" :rules="rules.DateReceived" starttoday="false" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-text-field ref="Name" counter="100" label="_Name_" v-model="itemSelected.Name" :rules="rules.Name" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-textarea ref="Position" counter="200" label="_Position_" v-model="itemSelected.Position" :rules="rules.Position" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-textarea ref="CompanyName" counter="500" label="_CompanyName_" v-model="itemSelected.CompanyName" :rules="rules.CompanyName" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-textarea ref="Address" counter="1000" label="_Address_" v-model="itemSelected.Address" :rules="rules.Address" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-text-field ref="Tel" counter="50" label="_Tel_" v-model="itemSelected.Tel" :rules="rules.Tel" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-text-field ref="Fax" counter="50" label="_Fax_" v-model="itemSelected.Fax" :rules="rules.Fax" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-text-field ref="Email" counter="100" label="_Email_" v-model="itemSelected.Email" :rules="rules.Email" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-text-field ref="Rpt_Address_YN" counter="1" label="_Rpt_Address_YN_" v-model="itemSelected.Rpt_Address_YN" :rules="rules.Rpt_Address_YN" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-textarea ref="Rpt_CompanyName" counter="500" label="_Rpt_CompanyName_" v-model="itemSelected.Rpt_CompanyName" :rules="rules.Rpt_CompanyName" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-textarea ref="Rpt_Address" counter="1000" label="_Rpt_Address_" v-model="itemSelected.Rpt_Address" :rules="rules.Rpt_Address" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-text-field ref="Sample_condition" counter="1" label="_Sample_condition_" v-model="itemSelected.Sample_condition" :rules="rules.Sample_condition" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-textarea ref="Sample_note" counter="1000" label="_Sample_note_" v-model="itemSelected.Sample_note" :rules="rules.Sample_note" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-text-field ref="Sample_Preservation" counter="1" label="_Sample_Preservation_" v-model="itemSelected.Sample_Preservation" :rules="rules.Sample_Preservation" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-textarea ref="Sample_Preservation_Condition" counter="1000" label="_Sample_Preservation_Condition_" v-model="itemSelected.Sample_Preservation_Condition" :rules="rules.Sample_Preservation_Condition" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-text-field ref="Return_Sample" counter="1" label="_Return_Sample_" v-model="itemSelected.Return_Sample" :rules="rules.Return_Sample" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-text-field ref="Report_TH" counter="4" label="_Report_TH_" v-model="itemSelected.Report_TH" :rules="rules.Report_TH" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-text-field ref="Report_EN" counter="4" label="_Report_EN_" v-model="itemSelected.Report_EN" :rules="rules.Report_EN" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-text-field ref="Report_Reception" counter="1" label="_Report_Reception_" v-model="itemSelected.Report_Reception" :rules="rules.Report_Reception" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-text-field ref="NeedUncertainly" counter="1" label="_NeedUncertainly_" v-model="itemSelected.NeedUncertainly" :rules="rules.NeedUncertainly" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-text-field ref="Customer" counter="100" label="_Customer_" v-model="itemSelected.Customer" :rules="rules.Customer" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-text-field ref="TAIStaff" counter="100" label="_TAIStaff_" v-model="itemSelected.TAIStaff" :rules="rules.TAIStaff" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-textarea ref="Review" counter="1000" label="_Review_" v-model="itemSelected.Review" :rules="rules.Review" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-text-field ref="Estimate_day" counter="4" label="_Estimate_day_" v-model="itemSelected.Estimate_day" :rules="rules.Estimate_day" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <date-input ref="Estimate_date" label="_Estimate_date_" v-model="itemSelected.Estimate_date" :rules="rules.Estimate_date" starttoday="false" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-text-field ref="Summary" counter="1" label="_Summary_" v-model="itemSelected.Summary" :rules="rules.Summary" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-textarea ref="Case_condition" counter="1000" label="_Case_condition_" v-model="itemSelected.Case_condition" :rules="rules.Case_condition" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <v-text-field ref="ReviewBy" counter="100" label="_ReviewBy_" v-model="itemSelected.ReviewBy" :rules="rules.ReviewBy" :dense="text_filled" :filled="text_filled" />
          </v-col>

          <v-col cols="12" sm="6" class="pr-2">
            <date-input ref="ReviewDate" label="_ReviewDate_" v-model="itemSelected.ReviewDate" :rules="rules.ReviewDate" starttoday="false" :dense="text_filled" :filled="text_filled" />
          </v-col>

        </v-row>
      </v-container>
    </v-form>
  </v-card>  
</template>

<script>
import itemService from '@/store/api/services/customersService'
export default {
  name: 'testingReqEdit',
  components: {
    // VueSignaturePad,
    // Itisopdf
  },
  props: {
    dialogClose: {
      type: Boolean
    },
    itemSelected: {
      type: Object,
      default: function() {
        return {}
      }
    },
    action: {
      type: String,
      default: function() {
        return 'add'
      }
    },
  },
  data() {
    return {
      pathStatic: process.env.VUE_APP_STATIC,
      errorMessages: [],
      lazy: false,
      debug: false,
      formValid: true,
      loading: true,
      text_filled: true,
      oldItem: {},
      rules: {
        ID: [
        ],
        ReqOnlineNo: [],
        ReqNo: [],
        DateReceived: [],
        Name: [],
        Position: [],
        CompanyName: [],
        Address: [],
        Tel: [],
        Fax: [],
        Email: [],
        Rpt_Address_YN: [],
        Rpt_CompanyName: [],
        Rpt_Address: [],
        Sample_condition: [],
        Sample_note: [],
        Sample_Preservation: [],
        Sample_Preservation_Condition: [],
        Return_Sample: [],
        Report_TH: [],
        Report_EN: [],
        Report_Reception: [],
        NeedUncertainly: [],
        Customer: [],
        TAIStaff: [],
        Review: [],
        Estimate_day: [],
        Estimate_date: [],
        Summary: [],
        Case_condition: [],
        ReviewBy: [],
        ReviewDate: [],
            // val => (!!val) || 'This field is required',
            // val => (!!val.toString()) || 'ห้ามเป็นค่าว่าง',
            // val => (val && val.length >= 3) || 'ต้องมีอย่างน้อย 3 ตัวอักษร',
            // val => (((val.length || 0) <= 500) ) || 'ต้องไม่เกิน 500 ตัวอักษร',
            // val => (!val.trim() || !isNaN((val)) ) || 'ต้องเป็นตัวเลข',
            // val => (Number.isInteger(parseFloat(val) ) ) || 'ต้องเป็นจำนวนเต็ม',
            // val => ((val >= 0 && val <= 999) ) || 'Number has to be between 0 and 999',

            // val => { // email check
            //   const patternEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            //   return patternEmail.test(val) || 'Invalid e-mail.'
            // },
      },
      //data()
    }
  },
  watch: {
    itemSelected: function(value, oldValue) {
      this.$nextTick(() => {
        console.log(value)
        if (value.ID !== oldValue.ID){
          console.log('change Key')
          this.initLoad()
        }
      })
    },
    formValid: function(value) {
      this.$emit('valid', value)
    },
    //watch()
  },
  computed: {
  //computed()
  },
  mounted: function() {
    this.initLoad()
    //mounted()
  },
  methods: {
    checkPermission(permissionArray) {
      return this.$store.getters.checkPermission(permissionArray)
    },
    errorHandel(res) {
      if (res.status === 401) {
        this.redirect = '/signin'
        this.$router.push(this.redirect)
      }
    },
    initLoad() {
      this.loading = true
      this.oldItem = Object.assign({}, this.itemSelected)
      this.$refs.form.resetValidation()
      if (this.action === 'add' || this.action === '') {
        console.log('init field for add action', this.itemSelected)
        // this.$refs.{{input-Date}}.setToday()
      }
      console.log('init', this.itemSelected)
      this.loading = false
    },
    itemCancel() {
      this.itemSelected = Object.assign({}, this.oldItem)
    },
    async Save() {
      this.loading = true
      console.log('testingReqEdit Save 1')
      if (this.itemSelected.ModifyCode) {
        if (this.itemSelected.ModifyCode.substr(0, 4) !== this.$store.state.users.main.empCode) {
          this.itemSelected.ModifyCode = this.$store.state.users.main.empCode + ',' + this.itemSelected.ModifyCode
          this.itemSelected.ModifyCode = this.itemSelected.ModifyCode.substr(0, 25)
        }
      } else {
        this.itemSelected.ModifyCode = this.$store.state.users.main.empCode
      }
      var modifyDate = new Date().toISOString().slice(0, 19)
      this.itemSelected.ModifyDate = modifyDate
      if (this.action !== 'add') {
        // Update Event
        console.log('testingReqEdit Save Update')
        let response = await itemService.testingReqUpdate(this.itemSelected)
        console.log('testingReqEdit Save Update then')
        if (response.data.error === '') {
          console.log('testingReqEdit Save Update then OK')
          this.itemSelected = response.data.data[0]
          let itemSelected_update = response.data.data[0] // this.itemSelected
          this.$emit('update', itemSelected_update)
          this.loading = false
          return true
        } else {
          console.log('testingReqEdit Save Update then error')
          alert('!!เกิดข้อผิดพลาด\n' + response.data.error)
          this.loading = false            
          return false
        }
      } else {
        // Insert Event
        console.log('testingReqEdit Save Insert')
        let response = await itemService.testingReqInsert(this.itemSelected)
        console.log('testingReqEdit Save Insert then ')
        if (response.data.error === '') {
          console.log('testingReqEdit Save Insert then OK')
          // this.itemSelected = response.data.data[0]
          let itemSelected = response.data.data[0] // this.itemSelected
          this.$emit('update', itemSelected)
          this.loading = false
          return true
        } else {
          console.log('testingReqEdit Save Insert then Error')
          alert('!!เกิดข้อผิดพลาด\n' + response.data.error)
          this.loading = false
          return false
        }
      }
    },
    //methods()
  }
}
</script>
<style>
.small-radio i {
  font-size: 15px;
}
.small-radio label {
  font-size: 14px;
  padding-left: 0px;
  margin-left: -4px;
}
.small-radio .v-radio {
  padding: 0px;
}
.small-radio [class*="__ripple"] {
  left: -9;
}
</style>
<style scoped>
</style>
